module.exports = __webpack_public_path__ + "img/mobile_btn4.d88c114a.png";